import React, { useEffect, useState, useReducer } from 'react';
import { useAuth } from '../../Context';

import { Empty, Row, Col, Typography, Button, Space, Table, Form, Modal, Spin, Tooltip, message, Popover, Avatar, Card, Select } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { PlusOutlined, EditOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';

import { EVENT_COMPARISON_LIST, EVENT_COMPARISON_LIST_SUCCESS, EVENT_COMPARISON_LIST_ERROR } from './constants';
import { EVENT_COMPARISON_DETAILS_SUCCESS } from './constants';
import { ADD_EVENT_COMPARISON_DETAILS, ADD_EVENT_COMPARISON_DETAILS_SUCCESS, ADD_EVENT_COMPARISON_DETAILS_ERROR } from './constants';
import { UPDATE_EVENT_COMPARISON, UPDATE_EVENT_COMPARISON_SUCCESS, UPDATE_EVENT_COMPARISON_ERROR } from './constants';
import { DELETE_EVENT_COMPARISON, DELETE_EVENT_COMPARISON_SUCCESS, DELETE_EVENT_COMPARISON_ERROR } from './constants';

import EventComparisonReducer from './reducer';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';

import { useFormik } from 'formik';
import axios from 'axios';
import { InfoOutlined, RetweetOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

export default function EventComparison() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {eventComparisons : [], details: null, pending: false, error: false };
	const [data, dispatch] = useReducer(EventComparisonReducer, initalState);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const [showAddEventComparisonModal, setShowAddEventComparisonModal] = useState(false);
	const [showEditEventComparisonModal, setShowEditEventComparisonModal] = useState(false);
	const [showDeleteEventComparisonModal, setShowDeleteEventComparisonModal] = useState(false);
	const [pidsId, setPidsId] = useState(null);

	const {getPids, pidsData, getChannels, channelData, wellchanneldata, getWellChannels, getAllEvents, eventsData} = useAuth();

	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const navigate = useNavigate();

	let pidsList = [];
	const channelList = [];


	pidsData && pidsData.map((item) => {
		pidsList.push({
			value : item.id,
			label : item.name.toUpperCase()
		});
	});

	pidsList.sort((a,b) => { return a.value - b.value; });

	channelData && channelData.map((item) => {
		channelList.push({
			value : item.channelId,
			label : item.name
		});
	});	

	const columns = [
		{
			title: langdata && langdata.Activityname ? langdata.Activityname : 'Activity Name',
			dataIndex: 'name',
			key: 'name',
			render: (text, record) => <a onClick={()=>{openEditEventComparisonModal(record);}}>{text}</a>,
		},
		{
			title: `${langdata && langdata.PIDS ? langdata.PIDS :'PIDS'}`,
			dataIndex: 'pidsinfoId',
			key: 'pidsinfoId',
			render: (_, record) => (
				
				<>
					{pidsData && pidsData.map((pids) => { if (record.pidsinfoId === pids.id){ return pids.name.toUpperCase();} })}
				</>
			)
			
		},
		{
			title: `${langdata && langdata.Channel ? langdata.Channel :'Channel'}`,
			dataIndex: 'channelId',
			key: 'channelId',
			render: (_, record) => (				
				
				<>
					{wellchanneldata && wellchanneldata.map((channel) => { if (record.channelId === channel.channelId && record.pidsinfoId == channel.pidsinfoId){ return channel.name;} })}
				</>
			)
		},
		{
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				permission === 'superadmin' || permission === 'admin' ? (
					<Space size="middle">
						<a title={langdata && langdata.EditEventType ? langdata.EditEventType : 'Edit Event Type'} onClick={()=>{openEditEventComparisonModal(record);}}><EditOutlined/></a>
						<a title={langdata && langdata.DeleteEventType ? langdata.DeleteEventType :'Delete Event Type'} onClick={()=>{openDeleteEventComparisonModal(record);}}><DeleteOutlined /></a>
					</Space>
				) : (
					<Space size="middle">
						<a title={langdata && langdata.EditEventType ? langdata.EditEventType : 'Edit Event Type'} onClick={()=>{openEditEventComparisonModal(record);}}><EyeOutlined/></a>
					</Space>
				)
			)
		}
	];

	const openAddEventComparisonModal = () => {
		getAllEvents(authtoken);
		getPids(authtoken);
		setShowAddEventComparisonModal(true);
	};


	let eventsList = [];

	eventsData && eventsData.map((item) => {
		eventsList.push({
			value: item.eventType,
			label: item.eventType
		});
	});


	const cloaseAddEventComparisonModal = () => {
		setPidsId(null);
		addEventComparisonFormik.setFieldValue('channelId', null);
		setShowAddEventComparisonModal(false);
	};

	const openEditEventComparisonModal = (details) => {
		getAllEvents(authtoken);
		getPids(authtoken);
		getChannels(authtoken,details.pidsinfoId);
		setShowEditEventComparisonModal(true);
		dispatch({type: EVENT_COMPARISON_DETAILS_SUCCESS, payload:details});
		
	};

	const closeEditEventComparisonModal = () => {
		updateEventComparisonFormik.resetForm();
		setShowEditEventComparisonModal(false);
	};

	const openDeleteEventComparisonModal = (details) => {
		dispatch({type: EVENT_COMPARISON_DETAILS_SUCCESS, payload:details});
		setShowDeleteEventComparisonModal(true);
	};

	const deleteEventComparison = () => {
		const id = parseInt(data.details.id);
    
		dispatch({ type: DELETE_EVENT_COMPARISON });

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/comparisoneventsconfig/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_EVENT_COMPARISON_SUCCESS, payload: response});
					setShowDeleteEventComparisonModal(false);   
					loadEventComparison();       
				} else {
					dispatch({type:DELETE_EVENT_COMPARISON_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_EVENT_COMPARISON_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	const closeDeleteEventComparisonModal = () => {
		setShowDeleteEventComparisonModal(false);
	};

	useEffect(() => {
		if(featuresModule.eventComparisonEnabled == false) {
			navigate('/dashboard');
		}
		
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 410);
	}, []);

	useEffect(() => {
		getPids(authtoken);
		getWellChannels(authtoken,null,null);

		dispatch( { type: EVENT_COMPARISON_LIST });
      
		loadEventComparison();
	}, []);

	const loadEventComparison = () => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/comparisoneventsconfig`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
  
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {					
					dispatch({type:EVENT_COMPARISON_LIST_SUCCESS, payload: response.data.data});
				}
			})
			.catch((error) => {
				dispatch({type:EVENT_COMPARISON_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};


	const addEventComparisonFormik = useFormik({
		initialValues: {
			name: '',
			pidsinfoId : null,
			channelId :  null,
		},
		onSubmit: (values) => {
			const name = values.name ? values.name : '';
			const pidsinfoId = values.pidsinfoId ? values.pidsinfoId : 0;
			const channelId = values.channelId ? values.channelId : 0;

			if (!name || name == null || name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseprovideavalidactivityname ? langdata.Pleaseprovideavalidactivityname : 'Please provide a valid activity name.' });
				return false;
			}

			if(!pidsinfoId || ! channelId){
				Modal.warning({title : langdata && langdata.Pleasefillallthemandatoryfields ? langdata.Pleasefillallthemandatoryfields : 'Please fill all the mandatory fields'});
				return false;
			}
		
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/comparisoneventsconfig`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name: name,
					pidsinfoId: pidsinfoId,
					channelId: channelId
				}
			};

			dispatch( { type: ADD_EVENT_COMPARISON_DETAILS });
      
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: ADD_EVENT_COMPARISON_DETAILS_SUCCESS, payload: response});
						Modal.success({ title: langdata && langdata.Eventtypesavedsuccessfully ? langdata.Eventtypesavedsuccessfully : 'Event type saved successfully.' });
						setShowAddEventComparisonModal(false);
						loadEventComparison();
					} else {
						dispatch({type: ADD_EVENT_COMPARISON_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.Unabletosavetheeventtype ? langdata.Unabletosavetheeventtype : 'Unable to save the event type.' });  
					}
				})
				.catch((error) => {
					dispatch({type: ADD_EVENT_COMPARISON_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});

	const updateEventComparisonFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: data.details ? data.details.name : '',
			pidsinfoId: data.details ? data.details.pidsinfoId : 0,
			channelId: data.details ? data.details.channelId : 0
		},
		onSubmit: (values) => {

			const id = data.details.id;
			const name = values.name ? values.name : '';
			const pidsinfoId = values.pidsinfoId ? values.pidsinfoId : 0;
			const channelId = values.channelId ? values.channelId : 0;

			if (!name || name == null || name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseprovideavalidactivityname ? langdata.Pleaseprovideavalidactivityname : 'Please provide a valid activity name.' });
				return false;
			}

			if(!pidsinfoId || ! channelId){
				Modal.warning({title : langdata && langdata.Pleasefillallthemandatoryfields ? langdata.Pleasefillallthemandatoryfields : 'Please fill all the mandatory fields'});
				return false;
			}

			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/comparisoneventsconfig/${id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name: name,
					pidsinfoId: pidsinfoId,
					channelId: channelId
				}
			};

			dispatch( { type: UPDATE_EVENT_COMPARISON });

			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: UPDATE_EVENT_COMPARISON_SUCCESS, payload:response});
						Modal.success({ title: langdata && langdata.Eventtypeupdatedsuccessfully ? langdata.Eventtypeupdatedsuccessfully : 'Event type updated successfully.' });
						setShowEditEventComparisonModal(false);
						loadEventComparison();
					} else {
						dispatch({type: UPDATE_EVENT_COMPARISON_ERROR});
						Modal.warning({ title: langdata && langdata.Unabletoupdatetheeventtype ? langdata.Unabletoupdatetheeventtype : 'Unable to update the event type.' });  
					}
				})
				.catch((error) => {
					dispatch({type: UPDATE_EVENT_COMPARISON_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});

	const handlePids = (value) => {
		getChannels(authtoken,value);
		setPidsId(value);
	};

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{ langdata && langdata.eventcomparisoninfo ? langdata.eventcomparisoninfo :  'This module is to manage the event types, which are compared with the hardware predicted event type based on a particular PID and channel.'}</p>
		</Card>
	);

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());	

	return (
		permission==='superadmin' || permission === 'admin' ? 

			<>
				<Content>
					<Row style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center',
					}}
					>

						<Col span={12}>
							<Row>
								<Space>
									<RetweetOutlined style={{fontSize:'30px'}}/>
									{/* </Col> */}
								</Space>
								<Space>&nbsp;&nbsp;</Space>
								<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.EventComparison ? langdata.EventComparison : 'Event Comparison' }</Title>
							</Row>
						</Col>
					
						<Col span={12}>
							<Row justify="end">
								<Col>
									<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
										<Space>
											{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={openAddEventComparisonModal} style={{margin:'5px'}} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button> : null }
										</Space>
									</Tooltip>
									<Space>&nbsp;&nbsp;</Space>
									<Space>
										<Typography>
											<Popover title={langdata && langdata.EventComparison ? langdata.EventComparison : 'Event Comparison' }  content={infoContent} trigger="click">
												<Avatar size="small"><InfoOutlined /></Avatar>
											</Popover>
										</Typography>
									</Space>
								</Col>
							</Row>
						</Col>
					</Row>
					<Row span={24} style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={24}>
							{ data && data.eventComparisons.length > 0 ? (
								<Table
									scroll={{
										x: 900,
									}} 
									columns={columns} 
									dataSource={data && data.eventComparisons} 
								/>
							)
								:
								(
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								)}
						</Col>
					</Row>
				</Content>

				<Spin fullscreen spinning={data.pending} />
      
				{/* Add Event Comparison Starts */}
				<Modal
					title={langdata && langdata.AddEventType ? langdata.AddEventType : 'Add Event Type' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={showAddEventComparisonModal}
					onOk={{cloaseAddEventComparisonModal}}
					onCancel={cloaseAddEventComparisonModal}
					footer={[
					// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={cloaseAddEventComparisonModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addEventComparisonFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={addEventComparisonFormik.handleSubmit}>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="name" label={langdata && langdata.Activityname ? langdata.Activityname : 'Activity Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenteractivityname ? langdata.Pleaseenteractivityname : 'Please enter activity name' }]} >
									<Select
										name="name"
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.Pleaseenteractivityname ? langdata.Pleaseenteractivityname : 'Please enter activity name'}
										optionFilterProp="children"
										options={eventsList}
										value={addEventComparisonFormik.values.name}
										onChange={(value) =>  {addEventComparisonFormik.setFieldValue('name', value);}}
										// onSelect={addEventComparisonFormik.handleChange}

									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.PIDS ? langdata.PIDS: 'PIDS'} name="pidsinfoId" rules={[{ required: true }]}>
									<Select
										name="pidsinfoId" 
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.PIDS ? langdata.PIDS: 'PIDS'}
										optionFilterProp="children"
										options={pidsList}
										onSelect={handlePids}
										onChange={(value) => {addEventComparisonFormik.setFieldValue('pidsinfoId', value); addEventComparisonFormik.setFieldValue('channelId', null);}}
										value={addEventComparisonFormik.values.pidsinfoId}
										// defaultValue={}
									/>												
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Channeldetails ? langdata.Channeldetails: 'Channel details'} rules={[{ required: true }]} required>
									<Select
										name="channelId" 
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.Channeldetails ? langdata.Channeldetails: 'Channel details'}
										optionFilterProp="children"
										options={channelList}
										onChange={(value) => {addEventComparisonFormik.setFieldValue('channelId', value);}}
										value={addEventComparisonFormik.values.channelId}
										// defaultValue={}
										disabled={!pidsId ? true : false}
									/>												
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
				{/* Add Event Comparison Ends */}

				{/* Edit Event Comparison Starts */}
				<Modal
					title={langdata && langdata.EditEventType ? langdata.EditEventType : 'Edit Event Type'}
					centered
					open={showEditEventComparisonModal}
					onOk={{closeEditEventComparisonModal}}
					onCancel={closeEditEventComparisonModal}
					footer={[
					// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={closeEditEventComparisonModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={updateEventComparisonFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={updateEventComparisonFormik.handleSubmit}>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Activityname ? langdata.Activityname : 'Activity Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenteractivityname ? langdata.Pleaseenteractivityname : 'Please enter activity name' }]} required>
									<Select
										name="name"
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.Pleaseenteractivityname ? langdata.Pleaseenteractivityname : 'Please enter activity name'}
										optionFilterProp="children"
										options={eventsList}
										value={updateEventComparisonFormik.values.name}
										onChange={(value) =>  {updateEventComparisonFormik.setFieldValue('name', value);}}
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.PIDS ? langdata.PIDS:'PIDS'} rules={[{ required: true }]} required>
									<Select
										name="pidsinfoId" 
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.PIDS ? langdata.PIDS:'PIDS'}
										optionFilterProp="children"
										options={pidsList}
										onSelect={handlePids}
										onChange={(value) => {updateEventComparisonFormik.setFieldValue('pidsinfoId', value); updateEventComparisonFormik.setFieldValue('channelId', null);}}
										value={updateEventComparisonFormik.values.pidsinfoId}
										defaultValue={updateEventComparisonFormik.values.pidsinfoId}
									/>												
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Channeldetails ? langdata.Channeldetails: 'Channel details'} rules={[{ required: true }]} required>

									<Select
										name="channelId" 
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.Channeldetails ? langdata.Channeldetails:'Channel details'}
										optionFilterProp="children"
										options={channelList}
										onChange={(value) => {updateEventComparisonFormik.setFieldValue('channelId', value);}}
										// value={formik.values.channelId}
										// defaultValue={formik.values.channelId}
										value={updateEventComparisonFormik.values.channelId}
										disabled={!updateEventComparisonFormik.values.pidsinfoId ? true : false}
									/>
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
				{/* Edit Event Comparison Ends */}

				{/* Delete Event Comparison Starts */}
				<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteEventComparisonModal} onOk={deleteEventComparison} onCancel={closeDeleteEventComparisonModal}>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={1}>
							<DeleteOutlined  style={{ fontSize: '14px'}}/>
						</Col>
						<Col span={23}> {langdata && langdata.Areyousureyouwanttodeletethiseventtype ? langdata.Areyousureyouwanttodeletethiseventtype : 'Are you sure you want to delete this event type?' }</Col>
					</Row>
				</Modal>
				{/* Delete Event Comparison Ends */}
			</> : null
	);
}